// Quake 3 script tokenizer, shared by shader scripts (render) and .arena
// files (map info on the client and the server).

export interface Token {
  text: string;
  newline: boolean; // first token on its line
  quoted: boolean;
}

/** Q3 script tokenizer (shaders, .arena files): words, "quoted strings", braces, comments skipped. */
export function tokenize(src: string): Token[] {
  const tokens: Token[] = [];
  let i = 0;
  let newline = true;
  const n = src.length;
  while (i < n) {
    const c = src[i];
    if (c === '\n') {
      newline = true;
      i++;
      continue;
    }
    if (c <= ' ') {
      i++;
      continue;
    }
    if (c === '/' && src[i + 1] === '/') {
      while (i < n && src[i] !== '\n') i++;
      continue;
    }
    if (c === '/' && src[i + 1] === '*') {
      i += 2;
      while (i < n && !(src[i] === '*' && src[i + 1] === '/')) {
        if (src[i] === '\n') newline = true;
        i++;
      }
      i += 2;
      continue;
    }
    let text: string;
    const quoted = c === '"';
    if (quoted) {
      const end = src.indexOf('"', i + 1);
      text = src.slice(i + 1, end < 0 ? n : end);
      i = end < 0 ? n : end + 1;
    } else if (c === '{' || c === '}') {
      text = c;
      i++;
    } else {
      const start = i;
      while (i < n && src[i] > ' ' && src[i] !== '{' && src[i] !== '}' && !(src[i] === '/' && src[i + 1] === '/')) i++;
      text = src.slice(start, i);
    }
    tokens.push({ text, newline, quoted });
    newline = false;
  }
  return tokens;
}
